import GeolocationErrorBody from '@/geolocation/screens/GeolocationError/GeolocationErrorBody';
import GeolocationErrorActionButtons from '@/geolocation/screens/GeolocationError/GeolocationErrorActionButtons';
import PluginErrorBody from '@/geolocation/screens/PluginError/PluginErrorBody';
import PluginErrorButtonActions from '@/geolocation/screens/PluginError/PluginErrorActionButtons';
import { TFunction } from 'i18next';

const getGeolocationModalConfig = (t: TFunction<'translation', undefined>) => {
  const translation = 'PLCNotInstalled';

  return {
    geolocationError: {
      body: GeolocationErrorBody,
      actionButtons: GeolocationErrorActionButtons,
      header: t('geocomply.locationError.title'),
    },
    pluginError: {
      body: PluginErrorBody,
      actionButtons: () => (
        <PluginErrorButtonActions translation={translation} />
      ),
      header: t(`${translation}.verifyLocation`),
    },
  };
};

export default getGeolocationModalConfig;
